export default {
	title: 'Portafolio',
	description: 'Todos mis proyectos Gerositus',
	actions: {
		back_to_this: 'Volver al portafolio'
	},
	search_projects: 'Buscar proyectos',
	cta: {
		welcome: '¡Bienvenido y gracias por conectarte a Gerositus Strategy Suite!',
		subscribe: 'Suscríbete ahora',
		create_permission: 'para poder crear nuevos proyectos.'
	},
	tabs: {
		risks: {
			title: 'Parámetros de riesgos y oportunidades'
		}
	}
};
